
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue"
import FormDialog from "@/components/dialogs/FormDialog.vue";
import { TakipEntity } from "@/entity/TakipEntity";
import BorcluCardInfo from "@/components/infos/BorcluCardInfo.vue";
import BorcluForm from "@/components/forms/BorcluForm.vue";
import {BorcluEntity} from "@/entity/BorcluEntity";
import {TakipDurumu} from "@/enum/TakipDurumu";

@Component({
  components: { BorcluCardInfo, BorcluForm, FormDialog, DeleteDialog }
})
export default class BorcluCardList extends Vue {
  @Prop({ required: true }) takipId!: number;
  @Prop({ default: false }) takipDetay!: boolean;
  @Prop({ type: Array, default: () => [] }) items!: any[];
  @Prop() takipDurumu!: TakipDurumu;
  @Prop() takip !: any;

  shortView: boolean = true;

  mounted() {
  }

  @Watch('items')
  onItemsChanged(newVal: any, oldVal: any) {
    if (Array.isArray(newVal) && newVal.length > 0) {
    } else {
    }
  }

  get visibleBorclular() {
    return this.shortView ? this.items.slice(0, 3) : this.items;
  }

  toggleView() {
    this.shortView = !this.shortView;
  }

  load() {
    this.$emit("load");
  }

  handleSuccess() {
    this.load();
    this.$emit("added");
  }

  handleItemLoad() {
    this.load();
  }
}
